<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="12">
              <b-form-group
                id="input-group-10"
                :label="$t('exams.name')"
                label-for="input-10"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-10"
                    v-model="newItem.name"
                    type="text"
                    :placeholder="$t('exams.name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-9"
                :label="$t('edu_courses.edu_courses')"
                label-for="input-9"
              >
                <validation-provider
                  #default="{ errors }"
                  name="course"
                  vid="course"
                  rules="required"
                >
                  <b-form-select
                    id="input-1"
                    v-model="newItem.course_id"
                    :options="course"
                    text-field="name"
                    value-field="id"
                    :placeholder="$t('program_lists.program_list')"
                  ></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .name -->
            </b-col>
            <!-- .type -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('exams.type')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="type"
                  vid="type"
                  rules="required"
                >
                  <select
                    name="type_id"
                    class="form-control"
                    v-model="newItem.type_id"
                  >
                    <option value="1">إختبار قبلي</option>
                    <option value="2">إختبار أساسي</option>
                    <option value="3">إختبار مباشر</option>
                    <option value="4">إختبار تسميع</option>
                    <option value="5">إختبار تلاوة</option>
                  </select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .full_grade --> </b-col
            ><b-col lg="3">
              <b-form-group
                id="input-group-2"
                :label="$t('exams.full_grade')"
                label-for="input-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="full_grade"
                  vid="full_grade"
                  rules="required"
                >
                  <b-form-input
                    id="input-2"
                    v-model="newItem.full_grade"
                    type="number"
                    :placeholder="$t('exams.full_grade')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .time --> </b-col
            ><b-col lg="3">
              <b-form-group
                id="input-group-3"
                :label="$t('exams.time')"
                label-for="input-3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="time"
                  vid="time"
                  rules="required"
                >
                  <b-form-input
                    id="input-3"
                    v-model="newItem.time"
                    type="number"
                    :placeholder="$t('exams.time')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .worthy -->
            </b-col>
            <b-col lg="3">
              <b-form-group
                id="input-group-6"
                :label="$t('exams.no_of_question')"
                label-for="input-6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="no_of_question"
                  vid="no_of_question"
                  rules="required"
                >
                  <b-form-input
                    id="input-6"
                    v-model="newItem.number_of_questions"
                    type="number"
                    :placeholder="$t('exams.no_of_question')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group> </b-col
            ><b-col lg="3">
              <b-form-group
                id="input-group-4"
                :label="$t('exams.worthy')"
                label-for="input-4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="worthy"
                  vid="worthy"
                  rules="required"
                >
                  <b-form-input
                    id="input-4"
                    v-model="newItem.worthy"
                    type="number"
                    :placeholder="$t('exams.worthy')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .filxable --> </b-col
            ><b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('exams.flixable')"
                label-for="input-5"
              >
                <b-form-checkbox
                  class="custom-control-primary"
                  name="check-button"
                  switch
                  v-model="newItem.filxable"
                  value="1"
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
              <!-- .number_of_questions -->
            </b-col>
            <!-- .random -->
            <b-col lg="6">
              <b-form-group
                id="input-group-7"
                :label="$t('exams.random')"
                label-for="input-7"
              >
                <b-form-checkbox
                  class="custom-control-primary"
                  name="check-button"
                  switch
                  v-model="newItem.random"
                  value="1"
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/ExamsController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import EduCoursesController from "@/Controllers/EduCoursesController";
const controller = new Controller();
export default {
  name: "ExamsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
      type: [],
      course: [],
    };
  },
  async created() {
    this.course = await new EduCoursesController().GetAll();
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      if (!this.newItem.filxable) this.newItem.filxable = 0;
      if (!this.newItem.random) this.newItem.random = 0;
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>
